module.exports = __webpack_public_path__ + "static/8d1c0fa9b5f0e73850dfc2c32a5cbe46.png";